/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

import { UserRole } from "constants/user"

export interface Link {
  id: number
  user_profile_service_id: any
  user_profile_grab_id: string
  link_entity_business_line: string
  link_entity_id: string
  link_entity_type: string
  created_at: Date
  updated_at: Date
  deleted_at?: any
}

export enum ParentEntityType {
  MERCHANT = 1,
  CONSUMER = 2,
  STORE = 3,
  INDIVIDUAL_MERCHANT = 4,
  INDIVIDUAL_STORE = 5,
  MLM_MERCHANT = 6,
  MLM_STORE = 7,
  MLM_TERMINAL = 8,
  GTWY_MERCHANT = 9,
  GTWY_STORE = 10,
  PTNR_MERCHANT = 11,
  PTNR_STORE = 12,
  OFFLINE_ACQUIRER = 13,
}

interface UserProfile {
  username: string
  parent_entity_country: string
  profile_status: string
  grab_id: string
  parent_entity_id: string
  parent_entity_type: ParentEntityType
  grab_food_entity_id: string
  role: UserRole
  links: Link[]
  service_id: number
  is_observer: boolean
}

export interface UserProfileInfo {
  country: string
  city_id: number
  user_profile: null | UserProfile
  analytics_id: string | null
  merchant_grab_id?: string
  business_line_ids: string[]
}
